import React, { useState, useEffect } from 'react';
import AlertMessage from '../../AlertMessage';
import loadingspinner from '../../assets/images/loading2.gif'


const RollNo = () => {
  const [classValue, setClassValue] = useState('');
  const [divisionValue, setDivisionValue] = useState('');
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [newStudents, setNewStudents] = useState([]);
  const [originalNewStudents, setOriginalNewStudents] = useState([]); // Store original unsorted new students
  const [classes, setClasses] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [isSorted, setIsSorted] = useState(false);
  const udiseNumber = localStorage.getItem("udiseNumber");
  const language = localStorage.getItem('language');
  const [rollNumberPrefix, setRollNumberPrefix] = useState('');
  const [savingData, setSavingData] = useState(false);


  const romanToInt = {
    I: 1,
    II: 2,
    III: 3,
    IV: 4,
    V: 5,
    VI: 6,
    VII: 7,
    VIII: 8,
    IX: 9,
    X: 10,
    XI: 11,
    XII: 12,
  };

  const marathiToInt = {
    'पहिली': 1,
    'दुसरी': 2,
    'तिसरी': 3,
    'चौथी': 4,
    'पाचवी': 5,
    'सहावी': 6,
    'सातवी': 7,
    'आठवी': 8,
    'नववी': 9,
    'दहावी': 10,
    'अकरावी': 11,
    'बारावी': 12
  };
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timeoutId = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 3000);
      return () => clearTimeout(timeoutId);
    }
  }, [alertMessage]);


  useEffect(() => {
    fetchClassDivData();
  }, [udiseNumber]);

  useEffect(() => {
    if (classValue) {
      fetchStudentsForClassAndDivision(classValue, divisionValue || '');
    }
  }, [classValue, divisionValue]);

  const fetchClassDivData = async () => {
    const storedDivClasses = localStorage.getItem("classDiv");
    if (storedDivClasses) {
      const data = JSON.parse(storedDivClasses);
      const classList = [];
      const divisionList = {};
      const activeStudentCounts = {};

      const db = await openDatabase();
      const transaction = db.transaction('studentData', 'readonly');
      const store = transaction.objectStore('studentData');
      const request = store.getAll();

      request.onsuccess = (event) => {
        const allStudents = event.target.result;

        // Count active students for each class
        allStudents.forEach(student => {
          const keyParts = student.id.split('-');
          const currentClass = keyParts.slice(0, -2).join('-'); // Adjust this line to get the full class name
          const isActive = student.isActive !== undefined ? student.isActive : true;
          if (isActive) {
            activeStudentCounts[currentClass] = (activeStudentCounts[currentClass] || 0) + 1;
          }
        });

        for (const [className, value] of Object.entries(data)) {
          if (value === true && activeStudentCounts[className] > 0) {
            classList.push(className);
            divisionList[className] = [];
          } else if (typeof value === 'object' && activeStudentCounts[className] > 0) {
            classList.push(className);
            divisionList[className] = Object.keys(value).filter(div => value[div]);
          }
        }

        setClasses(classList);
        setDivisions(divisionList);
      };

      request.onerror = (event) => {
        console.error('Error fetching students:', event.target.error);
      };
    }
  };

  const handleClassChange = (e) => {
    const selectedClass = e.target.value;
    // setSavingData(true)
    setClassValue(selectedClass);
    if (selectedClass && divisions[selectedClass]) {
      setDivisionValue(divisions[selectedClass][0] || '');
    } else {
      setDivisionValue('');
    }
  };

  const openDatabase = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1);

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        db.createObjectStore('studentData', { keyPath: 'id' });
      };

      request.onsuccess = (event) => {
        resolve(event.target.result);
      };

      request.onerror = (event) => {
        reject('Error opening database: ' + event.target.errorCode);
      };
    });
  };

  const handleDivisionChange = (e) => {
    setDivisionValue(e.target.value);
  };


  const fetchStudentsForClassAndDivision = async (classVal, divVal) => {
    console.log('Fetching students for class:', classVal, 'division:', divVal);
    setSavingData(true);

    const db = await openDatabase();
    const transaction = db.transaction('studentData', 'readonly');
    const store = transaction.objectStore('studentData');

    const serialNumbers = [];
    const request = store.getAll();

    request.onsuccess = async (event) => {
      const allStudents = event.target.result;

      allStudents.forEach(student => {
        const keyParts = student.id.split('-');
        const currentClass = keyParts.slice(0, -2).join('-');
        const division = keyParts[keyParts.length - 2];
        const serialNo = keyParts[keyParts.length - 1];
        console.log("currentClass", currentClass);
        console.log("division", division);
        console.log("serialNo", serialNo);

        const isActive = student.isActive !== undefined ? student.isActive : true;

        if (currentClass === classVal && (divVal === '' || division === divVal) && isActive) {
          serialNumbers.push(serialNo);
        }
      });

      if (serialNumbers.length > 0) {
        const studentPromises = serialNumbers.map(async (serialNo) => {
          const key = `${classVal}-${divVal}-${serialNo}`;
          const studentRequest = store.get(key);

          return new Promise((resolve) => {
            studentRequest.onsuccess = (event) => {
              const studentData = event.target.result;

              if (studentData) {
                const isActive = studentData.isActive !== undefined ? studentData.isActive : true;
                if (isActive) {
                  resolve({ ...studentData, srNo: serialNo });
                } else {
                  resolve(null);
                }
              } else {
                resolve(null);
              }
            };
            studentRequest.onerror = () => resolve(null);
          });
        });

        try {
          const students = await Promise.allSettled(studentPromises);
          const filteredStudents = students
            .filter(result => result.status === 'fulfilled' && result.value !== null)
            .map(result => result.value);

          // Sort by roll number if it exists
          const sortedStudents = filteredStudents.sort((a, b) => {
            const rollNoA = a.rollNo ? parseInt(a.rollNo, 10) : Infinity; // Handle undefined rollNo
            const rollNoB = b.rollNo ? parseInt(b.rollNo, 10) : Infinity; // Handle undefined rollNo
            return rollNoA - rollNoB;
          });

          // Separate students with and without roll numbers
          const studentsWithRollNumbers = sortedStudents.filter(student => student.rollNo);
          const studentsWithoutRollNumbers = sortedStudents.filter(student => !student.rollNo);

          setSelectedStudents(studentsWithRollNumbers);
          setNewStudents(studentsWithoutRollNumbers);
          setOriginalNewStudents(studentsWithoutRollNumbers); // Store original unsorted new students
        } catch (error) {
          console.error('Error fetching specific student data:', error);
          setAlertMessage('Error fetching specific student data.');
        }
      } else {
        setSelectedStudents([]);
        setNewStudents([]);
        setOriginalNewStudents([]);
        console.log('No students found for the selected class and division.');
      }
      setSavingData(false);
    };

    request.onerror = (event) => {
      console.error('Error fetching students:', event.target.error);
      setSavingData(false);
    };
  };


  // Update the handleRollNoChange function
  const handleRollNoChange = (srNo, newRollNo, isNewStudent = false) => {
    if (isNewStudent) {
      const updatedNewStudents = newStudents.map(student => {
        if (student.srNo === srNo) {
          return { ...student, rollNo: newRollNo }; // Update roll number
        }
        return student;
      });
      setNewStudents(updatedNewStudents); // Update state without re-sorting
    } else {
      const updatedSelectedStudents = selectedStudents.map(student => {
        if (student.srNo === srNo) {
          return { ...student, rollNo: newRollNo }; // Update roll number
        }
        return student;
      });
      setSelectedStudents(updatedSelectedStudents); // Update state without re-sorting
    }
  };

  const saveRollNumbers = async () => {
    try {
      const updates = {};
      const db = await openDatabase();
      const transaction = db.transaction(['studentData'], 'readwrite');
      const objectStore = transaction.objectStore('studentData');

      // Collect all updates for selected students and new students
      [...selectedStudents, ...newStudents].forEach(student => {
        console.log("student", student);

        const { serialNo, rollNo } = student;
        updates[`/schoolRegister/${udiseNumber}/studentData/${serialNo}/rollNo`] = rollNo;

        // Update rollNo in IndexedDB
        objectStore.put({ ...student, rollNo }); // Ensure the student object is updated with the new roll number
      });

      // Perform a single batch update in Firebase
      const response = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/.json`,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(updates),
        }
      );

      if (response.ok) {
        setAlertMessage('Roll numbers saved successfully!');
      } else {
        throw new Error('Failed to save roll numbers.');
      }
    } catch (error) {
      console.error('Error saving roll numbers:', error);
      setAlertMessage('Failed to save roll numbers.');
    }
  };

  const toggleSorting = (action) => {
    if (action === "revert") {
      // Revert to the original order
      setSelectedStudents(originalNewStudents.filter(student => student.rollNo)); // Revert selected students
      setNewStudents(originalNewStudents.filter(student => !student.rollNo)); // Revert new students
      setIsSorted(false); // Update sorting state
    } else if (action === "sortByName") {
      // Sort alphabetically by name
      const sortedCombinedStudents = [...selectedStudents, ...newStudents].sort((a, b) => {
        const nameA = `${a.stdName} ${a.stdSurname}`.toUpperCase();
        const nameB = `${b.stdName} ${b.stdSurname}`.toUpperCase();
        return nameA.localeCompare(nameB);
      });

      // Reassign roll numbers based on the new order
      const startingRollNo = 1;
      const studentsWithUpdatedRollNumbers = sortedCombinedStudents.map((student, index) => ({
        ...student,
        rollNo: `${rollNumberPrefix}${startingRollNo + index}`,
      }));

      // Separate the sorted students back into two groups
      const sortedWithRollNumbers = studentsWithUpdatedRollNumbers.filter(student => student.rollNo);
      const sortedWithoutRollNumbers = studentsWithUpdatedRollNumbers.filter(student => !student.rollNo);

      // Store original students only once (before sorting)
      if (!isSorted) {
        setOriginalNewStudents([...selectedStudents, ...newStudents]); // Save original before sorting
      }

      // Update both states with sorted data
      setSelectedStudents(sortedWithRollNumbers);
      setNewStudents(sortedWithoutRollNumbers);
      setIsSorted(true); // Update sorting state ```javascript
    } else if (action === "sortBySurname") {
      // Sort alphabetically by surname
      const sortedCombinedStudents = [...selectedStudents, ...newStudents].sort((a, b) => {
        const surnameA = (a.stdSurname || '').toUpperCase(); // Handle undefined surname
        const surnameB = (b.stdSurname || '').toUpperCase(); // Handle undefined surname
        return surnameA.localeCompare(surnameB);
      });

      // Reassign roll numbers based on the new order
      const startingRollNo = 1;
      const studentsWithUpdatedRollNumbers = sortedCombinedStudents.map((student, index) => ({
        ...student,
        rollNo: `${rollNumberPrefix}${startingRollNo + index}`,
      }));

      // Separate the sorted students back into two groups
      const sortedWithRollNumbers = studentsWithUpdatedRollNumbers.filter(student => student.rollNo);
      const sortedWithoutRollNumbers = studentsWithUpdatedRollNumbers.filter(student => !student.rollNo);

      // Store original students only once (before sorting)
      if (!isSorted) {
        setOriginalNewStudents([...selectedStudents, ...newStudents]); // Save original before sorting
      }

      // Update both states with sorted data
      setSelectedStudents(sortedWithRollNumbers);
      setNewStudents(sortedWithoutRollNumbers);
      setIsSorted(true); // Update sorting state
    } else if (action === "sortByRegisterNo") {
      // Sort by registerNo
      const sortedCombinedStudents = [...selectedStudents, ...newStudents].sort((a, b) => {
        const registerNoA = a.registerNo;
        const registerNoB = b.registerNo;
        return registerNoA - registerNoB; // Sort numerically by registerNo
      });

      // Reassign roll numbers based on the new order
      const startingRollNo = 1;
      const studentsWithUpdatedRollNumbers = sortedCombinedStudents.map((student, index) => ({
        ...student,
        rollNo: `${rollNumberPrefix}${startingRollNo + index}`,
      }));

      // Separate the sorted students back into two groups
      const sortedWithRollNumbers = studentsWithUpdatedRollNumbers.filter(student => student.rollNo);
      const sortedWithoutRollNumbers = studentsWithUpdatedRollNumbers.filter(student => !student.rollNo);

      // Store original students only once (before sorting)
      if (!isSorted) {
        setOriginalNewStudents([...selectedStudents, ...newStudents]); // Save original before sorting
      }

      // Update both states with sorted data
      setSelectedStudents(sortedWithRollNumbers);
      setNewStudents(sortedWithoutRollNumbers);
      setIsSorted(true); // Update sorting state
    } else if (action === "sortGirlsFirst") {
      // Sort by gender (Girls first) and then by name
      const sortedCombinedStudents = [...selectedStudents, ...newStudents].sort((a, b) => {
        if (a.gender === "female" && b.gender === "male") return -1;
        if (a.gender === "male" && b.gender === "female") return 1;
        const nameA = `${a.stdName} ${a.stdSurname}`.toUpperCase();
        const nameB = `${b.stdName} ${b.stdSurname}`.toUpperCase();
        return nameA.localeCompare(nameB);
      });

      // Reassign roll numbers based on the new order
      const startingRollNo = 1;
      const studentsWithUpdatedRollNumbers = sortedCombinedStudents.map((student, index) => ({
        ...student,
        rollNo: `${rollNumberPrefix}${startingRollNo + index}`,
      }));

      // Separate the sorted students back into two groups
      const sortedWithRollNumbers = studentsWithUpdatedRollNumbers.filter(student => student.rollNo);
      const sortedWithoutRollNumbers = studentsWithUpdatedRollNumbers.filter(student => !student.rollNo);

      // Store original students only once (before sorting)
      if (!isSorted) {
        setOriginalNewStudents([...selectedStudents, ...newStudents]); // Save original before sorting
      }

      // Update both states with sorted data
      setSelectedStudents(sortedWithRollNumbers);
      setNewStudents(sortedWithoutRollNumbers);
      setIsSorted(true); // Update sorting state
    } else if (action === "sortBoysFirst") {
      // Sort by gender (Boys first) and then by name
      const sortedCombinedStudents = [...selectedStudents, ...newStudents].sort((a, b) => {
        if (a.gender === "male" && b.gender === "female") return -1;
        if (a.gender === "female" && b.gender === "male") return 1;
        const nameA = `${a.stdName} ${a.stdSurname}`.toUpperCase();
        const nameB = `${b.stdName} ${b.stdSurname}`.toUpperCase();

        return nameA.localeCompare(nameB);
      });

      // Reassign roll numbers based on the new order
      const startingRollNo = 1;
      const studentsWithUpdatedRollNumbers = sortedCombinedStudents.map((student, index) => ({
        ...student,
        rollNo: `${rollNumberPrefix}${startingRollNo + index}`,
      }));

      // Separate the sorted students back into two groups
      const sortedWithRollNumbers = studentsWithUpdatedRollNumbers.filter(student => student.rollNo);
      const sortedWithoutRollNumbers = studentsWithUpdatedRollNumbers.filter(student => !student.rollNo);

      // Store original students only once (before sorting)
      if (!isSorted) {
        setOriginalNewStudents([...selectedStudents, ...newStudents]); // Save original before sorting
      }

      // Update both states with sorted data
      setSelectedStudents(sortedWithRollNumbers);
      setNewStudents(sortedWithoutRollNumbers);
      setIsSorted(true); // Update sorting state
    }
  };



  // Helper function to assign roll numbers with prefix
  const updateRollNumbersWithPrefix = (prefix, studentsWithRoll, studentsWithoutRoll) => {
    const combinedStudents = [...studentsWithRoll, ...studentsWithoutRoll];
    return combinedStudents.map((student, index) => ({
      ...student,
      rollNo: `${prefix}${index + 1}`,
    }));
  };

  // UseEffect to handle prefix change
  useEffect(() => {
    if (rollNumberPrefix) {
      const updatedStudents = updateRollNumbersWithPrefix(rollNumberPrefix, selectedStudents, newStudents);
      const updatedWithRoll = updatedStudents.filter(student => student.rollNo);
      const updatedWithoutRoll = updatedStudents.filter(student => !student.rollNo);

      setSelectedStudents(updatedWithRoll);
      setNewStudents(updatedWithoutRoll);
    }
  }, [rollNumberPrefix]);

  // Event handler for prefix change
  const handlePrefixChange = (e) => {
    setRollNumberPrefix(e.target.value);
  };

  const trimSpaces = (str) => {
    if (typeof str === 'string') {
      return str.trim();
    }
    return str;
  };

  const getUniqueClassOptions = (options) => {
    const trimmedOptions = options.map(trimSpaces);
    return Array.from(new Set(trimmedOptions)).filter(cls => cls !== ""); // Remove empty strings
  };

  return (
    <div>
      {/* <Sidebar /> */}
      <AlertMessage message={alertMessage} show={showAlert} />
      <div className='main-content-of-page text-center'>
        <h3 style={{ color: 'rgb(27, 67, 50)' }} className="title">{language === "English" ? "Students Roll No" : "विद्यार्थ्यांचे हजेरी क्रमांक"}</h3>

        <table className="table" style={{ width: '50%' }}>
          <tbody>
            <tr>
              <th>{language === "English" ? "Class" : "वर्ग"}</th>
              <td>
                <select
                  id="class"
                  value={classValue}
                  onChange={handleClassChange}
                  className="form-control custom-select"
                >
                  <option value="">{language === "English" ? "Select Class" : "वर्ग निवडा"}</option>
                  {getUniqueClassOptions(classes)
                    .sort((a, b) => {
                      const classA = a.split(' ')[1];
                      const classB = b.split(' ')[1];
                      let numA, numB;

                      if (language === "English") {
                        numA = romanToInt[classA] !== undefined ? romanToInt[classA] : 0;
                        numB = romanToInt[classB] !== undefined ? romanToInt[classB] : 0;
                      } else {
                        numA = marathiToInt[classA] !== undefined ? marathiToInt[classA] : 0; // Default to 0 if not found
                        numB = marathiToInt[classB] !== undefined ? marathiToInt[classB] : 0; // Default to 0 if not found
                      }

                      return numA - numB; // Sort based on the numerical value
                    })
                    .map((cls, index) => (
                      <option key={index} value={cls}>
                        {cls}
                      </option>
                    ))}
                </select>
              </td>
            </tr>

            <tr>
              <th>{language === "English" ? "Division" : "तुकडी"}</th>
              <td>
                <select
                  id="division"
                  value={divisionValue}
                  onChange={handleDivisionChange}
                  className="form-control custom-select"
                >
                  <option value="">{language === "English" ? "Select Division" : "तुकडी निवडा"}</option>
                  {classValue && divisions[classValue] && divisions[classValue].map((div, index) => (
                    <option key={index} value={div}>
                      {div}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
          </tbody>
        </table>
        {savingData && <img width={'80px'} className="registerLoading" src={loadingspinner} style={{ top: '50%', left: '55%' }} />}

        <div className="mt-5 mb-5">
          {(selectedStudents.length > 0 || newStudents.length > 0) && (
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
              {/* Dropdown */}
              <select
                onChange={(e) => toggleSorting(e.target.value)}
                className="form-control custom-select"
                style={{
                  width: '200px', height: '35px',
                  padding: '0.5rem',
                  borderRadius: '5px',
                  border: '1px solid #ced4da',
                  backgroundColor: '#f8f9fa',
                  cursor: 'pointer',
                }}
              >
                <option value="">
                  {language === "English" ? "Sort By" : "क्रमवारी लावा"}
                </option>
                <option value="sortByName">
                  {language === "English" ? "Sort Alphabetically by Name" : "नावानुसार वर्णक्रमानुसार क्रमवारी लावा"}
                </option>
                <option value="sortBySurname">
                  {language === "English" ? "Sort Alphabetically by Surname" : "आडनावानुसार वर्णक्रमानुसार क्रमवारी लावा"}
                </option>
                <option value="sortByRegisterNo">
                  {language === "English" ? "Sort by Register No" : "रजिस्टर क्रमांकानुसार क्रमवारी लावा"}
                </option>
                <option value="sortGirlsFirst">
                  {language === "English" ? "Sort by Gender (Girls First)" : "मुलींनुसार क्रमवारी लावा"}
                </option>
                <option value="sortBoysFirst">
                  {language === "English" ? "Sort by Gender (Boys First)" : "मुलांनुसार क्रमवारी लावा"}
                </option>
                <option value="revert">
                  {language === "English" ? "Revert to Original Order" : "मूळ क्रमांकावर परत या"}
                </option>
              </select>

              {/* Input for prefix */}
              <input
                type="text"
                id="rollNumberPrefix"
                value={rollNumberPrefix}
                onChange={handlePrefixChange}
                className="form-control"
                style={{
                  width: '200px', height: '35px',
                  padding: '0.5rem',
                  borderRadius: '5px',
                  border: '1px solid #ced4da',
                }}
                placeholder={language === "English" ? "Enter prefix" : "उपसर्ग प्रविष्ट करा"}
              />

              {/* Button */}
              <button
                onClick={saveRollNumbers}
                className="btn btn-primary"
                style={{
                  padding: '0.5rem 1rem',
                  borderRadius: '5px',
                  backgroundColor: '#8A1538', height: '35px',
                  border: 'none',
                  color: '#fff',
                  cursor: 'pointer',
                }}
              >
                {language === "English" ? "Save Roll Numbers" : "हजेरी क्रमांक जतन करा"}
              </button>
            </div>
          )}
        </div>



        {/* Show students who already have roll numbers */}
        {selectedStudents.length > 0 && (
          <div className="mt-5">
            <h5 style={{ fontWeight: '600', color: 'rgb(27, 67, 50)' }}>
              {language === "English" ? "Students" : "विद्यार्थी"}
            </h5>
            <table className="table" style={{ width: '50%', marginBottom: '30px' }}>
              <thead>
                <tr>
                  <th style={{ padding: 'auto 12px' }}>
                    {language === "English" ? "Roll No" : "हजेरी क्रमांक"}
                  </th>
                  <th style={{ padding: 'auto 12px' }}>
                    {language === "English" ? "Register No" : "रजिस्टर क्र."}
                  </th>
                  <th style={{ width: '100px' }}>
                    {language === "English" ? "Student Name" : "विद्यार्थ्याचे नाव"}
                  </th>
                </tr>
              </thead>
              <tbody>
                {selectedStudents.map((student) => (
                  <tr key={student.srNo}>
                    <td>
                      <input
                        type="text"
                        value={student.rollNo}
                        onChange={(e) => handleRollNoChange(student.srNo, e.target.value)}
                        className="form-control"
                        style={{
                          width: '80px',
                          padding: '0.25rem',
                          borderRadius: '4px',
                          border: '1px solid #ced4da',
                        }}
                      />
                    </td>
                    <td>{student.registerNo}</td>
                    <td>{student.stdName} {student.stdFather} {student.stdSurname}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}


        {/* Show newly added students */}
        {newStudents.length > 0 && (
          <div className="mt-5"  >
            <h5 style={{ fontWeight: '600', color: 'rgb(27, 67, 50)' }}> {language === "English" ? "Students" : "विद्यार्थी"}</h5>
            <table style={{ width: '600px', alignItems: 'center' }} className='table'>
              <thead>
                <tr>
                  <th style={{ padding: 'auto 12px' }}> {language === "English" ? "Roll No" : "हजेरी क्रमांक"}</th>
                  <th style={{ padding: 'auto 14px' }}> {language === "English" ? "Register No" : "रजिस्टर क्र."}</th>
                  <th style={{ width: '100px' }}> {language === "English" ? "Student Name" : "विद्यार्थ्याचे नाव"}</th>
                </tr>
              </thead>
              <tbody>
                {newStudents.map((student) => (
                  <tr key={student.srNo}>
                    <td>
                      <input
                        type="text"
                        value={student.rollNo}
                        onChange={(e) => handleRollNoChange(student.srNo, e.target.value, true)}
                        className="form-control"
                        style={{
                          width: '80px',
                          padding: '0.25rem',
                          borderRadius: '4px',
                          border: '1px solid #ced4da',
                        }}
                      />
                    </td>
                    <td>{student.registerNo}</td>
                    <td>{student.stdName} {student.stdFather} {student.stdSurname}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default RollNo;
